// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"706":"68fb7c31","741":"68fb7c31","3122":"68fb7c31","3888":"68fb7c31","6154":"7cff2fcf","6784":"13ad62b8","7015":"f51d26c2"}[chunkId] + ".chunk.css";
};